import { useState, useEffect, useRef } from 'react';
import './App.css';
import loadingicon from "./img/loading.png";
import { useParams } from 'react-router-dom';
import { translate } from './functions/translationHelper';
import { useLoadingRecovery } from './functions/useLoadingRecovery';


function LoadingScreen(props) {

  let { regionid } = useParams();
  const {
    needsManualReload: propsNeedsManualReload,
    newuser,
    onManualReload,
    onUserCreated,
    recoveryActive,
    recoveryTimeoutMs,
  } = props;

  const [isImgLoaded, setIsImgLoaded] = useState(false);
  const userCreationStarted = useRef(false);
  const lang = localStorage.getItem("language") || "en";
  const { needsManualReload, reloadNow, triggerRecovery } = useLoadingRecovery({
    active: recoveryActive !== false,
    timeoutMs: recoveryTimeoutMs,
  });
  const showManualReload = propsNeedsManualReload || needsManualReload;
  const handleManualReload = onManualReload || reloadNow;

  useEffect(() => {
    if (newuser) {
      if (userCreationStarted.current) {
        return;
      }

      const existingUuid = localStorage.getItem("uuid");

      if (existingUuid) {
        onUserCreated?.(existingUuid);
        return;
      }

      userCreationStarted.current = true;

      const creatUser = async () => {
        try {
          const response = await fetch(`${process.env.REACT_APP_API_URL}createAnonymousUser.php`);

          const data = await response.json();

          if(data.uuid !== undefined) {
            localStorage.setItem("uuid", data.uuid);
            localStorage.setItem("badgenotification", true);
            onUserCreated?.(data.uuid);
          } else {
            triggerRecovery();
          }


        } catch (error) {
          console.error('Error fetching data:', error);
          triggerRecovery();
        }
      }

      creatUser();
    }
  }, [newuser, onUserCreated, triggerRecovery]);
  
  return (
    <div className="loadingscreen">
      <img 
        src={`${process.env.REACT_APP_CONTENT_URL}${regionid}/logo.png`} 
        alt=""
        className={`loadinglogo ${isImgLoaded ? "loadinglogoloaded" : ""}`}
        onLoad={() => setIsImgLoaded(true)}
      />
      <img className='loadingicon' src={loadingicon} alt="" />
      {showManualReload &&
        <button className="loadingreloadbutton button-secondary" type="button" onClick={handleManualReload}>
          {translate("reload", lang)}
        </button>
      }
    </div>
  );
}

export default LoadingScreen;
